import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ParentFrameProvider } from '../../context/ParentFrame';
import { ROUTES } from '../../constants/routes.js';
import AccountManagementTabs from '../../molecules/AcctMgmt/AccountManagementTabs/AccountManagementTabs';

const AccountManagementSignInPage = React.lazy(() => import('../../molecules/AcctMgmt/AcctMgmtSignInPage'));

function AccountManagement() {
  // TODO: hide heading if url params contains heading=false
  return (
    <ParentFrameProvider>
      <Suspense>
        <div className="acc-management-wrapper">
          <h1>Account Settings</h1>
          <BrowserRouter>
            <Routes>
              <Route path={ROUTES.ACCOUNT_MANAGEMENT_SIGNIN} element={<AccountManagementSignInPage />} />
              <Route path={ROUTES.ACCOUNT_MANAGEMENT_MAIN} element={<AccountManagementTabs />} />
              <Route path="*" element={<AccountManagementSignInPage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </Suspense>
    </ParentFrameProvider>
  );
}

export default AccountManagement;
